import { TextField } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import SlidingComponent from "../../../../reusableComponents/slidingToggleComponent/SlidingComponent";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getCrusines } from "../../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import {
  admin_create_global_catalog,
  admin_update_global_catalog,
} from "../../../../../store/actions/SuperAdminActions/adminCreateCatalogue";
import { useFormik } from "formik";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import { useHistory } from "react-router-dom";

const validate = (values) => {
  const errors = {};
  if (values.name === "") {
    errors.name = "Catalogue name is required";
  }

  if (values.cuisin_type === "") {
    errors.cuisin_type = "Please select cuisine type";
  }

  return errors;
};

const AddGlobalCatalogue = (props) => {
  const [popularCuisines, setPopularCrusines] = useState([]);
  const [search, setSearch] = useState("");
  const [redirect, setRedirect] = useState(false);
  const [edit, setEdit] = useState(false);
  let history = useHistory();

  const onChangeStatus = () => {
    formik.setFieldValue("status", !formik.values.status);
  };

  const onSuccessGetCrusines = (data) => {
    let crusines = [];

    for (let i = 0; i < data.length; i++) {
      if (data[i].status === "APPROVED") {
        crusines.push({ name: data[i].title, id: data[i]._id });
      }
    }
    setPopularCrusines(crusines);
  };

  const filtereddata = popularCuisines.filter((item) => {
    return item && item.name && item.name.toLowerCase().includes(search);
  });

  const onErrorGetCruisnes = () => {};

  const onChangeCrusinType = (id) => {
    formik.setFieldValue("cuisin_type", id);
  };

  const onSuccess = () => {
    if (redirect) {
      history.push("/superadmin-global-catalogue");
    } else {
      formik.resetForm();
    }
    setEdit(false);
  };

  const onClickAdd = (status) => {
    setRedirect(status);
    formik.handleSubmit();
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      cuisin_type: "",
      description: "",
      status: false,
      catalogue_id: "",
    },
    validate,

    onSubmit: (values) => {
      const token = props.auth.user.accessToken;
      if (edit) {
        let catalogId = values._id;
        delete values["_id"];
        props.admin_update_global_catalog(token, values, catalogId, onSuccess);
      } else {
        props.admin_create_global_catalog(token, values, onSuccess);
      }
    },
  });

  useEffect(() => {
    props.getCrusines(onSuccessGetCrusines, onErrorGetCruisnes);
  }, []);

  useEffect(() => {
    if (props.editGlobalCatalog.edit) {
      formik.setValues(props.editGlobalCatalog);
      setEdit(true);
    }
  }, [props.editGlobalCatalog]);
  return (
    <React.Fragment>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="p-4">
            <div className="f20-700">Add Global Catalogue</div>
            <div className="mt-4">
              <div className="f16-500 mb-2">Catalogue Information</div>
              <Row>
                <Col md={4}>
                  <TextField
                    variant="outlined"
                    label="Catalogue Name"
                    fullWidth
                    className={`w-100 ${
                      formik.errors.name && formik.touched.name ? "enError" : ""
                    }`}
                    name="name"
                    onChange={formik.handleChange}
                    value={formik.values.name}
                    onBlur={formik.handleBlur}
                    //onInvalid={formik.errors.email && formik.touched.email}
                    isInvalid={formik.errors.name && formik.touched.name}
                  />
                  {formik.errors.name && formik.touched.name ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.name}
                    </div>
                  ) : null}
                  <br />
                  <div className="f16-500 mt-2">Select Cuisine</div>
                  <TextField
                    variant="outlined"
                    label="Search for cuisines"
                    fullWidth
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <div
                    className="mt-2"
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      overflow: "hidden",
                      overflowY: "scroll",
                      maxHeight: "15.66667vw",
                      minHeight: "15.66667vw",
                    }}
                  >
                    {filtereddata.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className={`col-4 p-0`}
                          align="center"
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() => onChangeCrusinType(item.id)}
                        >
                          <div
                            className={`w-100 status-selected-button-box font_20_m ${
                              formik.values.cuisin_type === item.id
                                ? "sts_sld_btn_box_a"
                                : ""
                            }`}
                          >
                            <div className="row justify-content-center">
                              <div className={`col-12`}>
                                <span className="f10-700">{item.name}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </Col>
              </Row>
              {formik.errors.cuisin_type && formik.touched.cuisin_type ? (
                <div className="pho_14_regular text-danger">
                  {formik.errors.cuisin_type}
                </div>
              ) : null}
              <Row className="mt-4">
                <Col md={4}>
                  <div className="mt-3">
                    <TextField
                      label="Description"
                      variant="outlined"
                      multiline={true}
                      fullWidth
                      rows={4}
                      name="description"
                      onChange={formik.handleChange}
                      value={formik.values.description}
                    />
                  </div>
                  <div className="mt-3">
                    <div className="f14-500 mb-2">Select Cuisine</div>
                    <div className="d-flex text-align-center">
                      <div className="mr-2">
                        {formik.values.status ? "" : "InActive"}
                      </div>
                      <SlidingComponent
                        onChange={() => onChangeStatus()}
                        name="approved"
                        checked={formik.values.status}
                        type={"checkbox"}
                        toggleclass={
                          "toggle vendor-super-admin-toggle d-flex align-items-center mb-2"
                        }
                        toggleinputclass={
                          "toggle__switch vendor-super-admin-toggle"
                        }
                        //   onChange={props.toggleFunction}
                        // slidingonClick={this.onSelecttogglestatusChange(data)}
                        //defaultChecked={false}
                      />
                      <div className="mr-2">
                        {formik.values.status ? "Active" : ""}
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <div class="d-flex align-items-center pt-5">
                  <button
                    type="button"
                    class="mr-4 px-5 btn-md py-2 btn btn-outline-secondary"
                    onClick={() => history.push("/superadmin-global-catalogue")}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    class="mr-4 px-5 btn-md py-2 btn btn-danger"
                    onClick={() => onClickAdd(true)}
                  >
                    {edit ? "Edit" : "Add"}
                  </button>
                  <button
                    type="button"
                    class="px-5 btn-md py-2 btn btn-outline-danger"
                    onClick={() => onClickAdd(false)}
                  >
                    {edit ? "Edit" : "Save"} & Add Another
                  </button>
                </div>
              </Row>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

AddGlobalCatalogue.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  editGlobalCatalog: state.commonSuperAdmin.editGlobalCatalog,
});

export default connect(mapStateToProps, {
  getCrusines,
  admin_create_global_catalog,
  admin_update_global_catalog,
})(AddGlobalCatalogue);
